module.exports = __webpack_public_path__ + "static/media/thank_you_wallpaper.b204b5a0.png";